import { render, staticRenderFns } from "./PelletsPriceComparison.vue?vue&type=template&id=34f5a3d5&scoped=true"
import script from "./PelletsPriceComparison.vue?vue&type=script&lang=ts"
export * from "./PelletsPriceComparison.vue?vue&type=script&lang=ts"
import style0 from "./PelletsPriceComparison.vue?vue&type=style&index=0&id=34f5a3d5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5a3d5",
  null
  
)

export default component.exports